<template>
	<div class="header-container">
		<!-- 头部背景图 -->
		<div class="header-bg row-center">
			<img src="../../assets/home/top_bg.png" alt="" />
		</div>
		<div class="header-content flex-center wrap">
			<div class="header-inner row-center">
				<!-- 顶部标题 -->
				<div class="header-title col-center">
					<div class="logo">
						<img src="../../assets/home/logo.png" alt="" />
					</div>
					<div class="title">
						<div>
							黑龙江省实践教学智慧平台
						</div>
						<div class="sub">
							Heilongjiang Province Practical Teaching Smart Platform
						</div>
					</div>
				</div>
				<div class="slot col-center">
					<slot></slot>
				</div>

			</div>
			<!-- 网站页脚 -->
			<floor class="pc"></floor>
		</div>
	</div>
</template>

<script>
	import floor from '@/components/floor/floor' //页脚
	export default {
		name: 'cus-header',
		props: {

		},
		components: {
			floor
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {

		},
		methods: {

		}

	}
</script>

<style lang="scss" scoped>
	.header-container {
		position: relative;

		.header-bg {
			position: absolute;
			width: 100%;
			min-width: 83.33333vw;
			top: 0;
			z-index: 0;

			img {
				min-width: 83.33333vw;
				width: 100%;
				max-height: 100vh;
				object-fit: cover;
			}
		}

		.header-content {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			min-width: 83.33333vw;
			height: 100vh;
			display: flex;
			flex-direction: column;

			.header-inner {
				width: 68.75vw;
				flex-wrap: wrap;
				margin: 0 auto;
				height: 0;
				flex-grow: 1;

				.header-title {
					padding: 2.2vw 0;

					.title-col {
						display: none;
					}

					.logo {
						width: 4.5833vw;
						height: 4.5833vw;
						flex-shrink: 0;
						margin-right: .520833vw;
					}

					.title {
						font-weight: 800;
						font-size: 2.60416vw;
						color: #FFFFFF;
						text-shadow: 0px 3px 0px rgba(73, 122, 194, 0.1);
						background: linear-gradient(0deg, #BBD7FF 0%, #FFFFFF 53.1494140625%);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;

						.sub {
							font-size: .9895833vw;
						}
					}

					img {
						width: 100%;
					}
				}

				.slot {
					width: 100%;
					position: relative;
					min-height: 32vw;
				}
			}
		}
	}

	.pc {
		display: block;
		padding-bottom: 2.08333vw;
		flex-shrink: 0;
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.header-container {
			.header-bg {
				width: 100%;
				position: absolute;
				left: 0;
				margin-left: 0;
				min-width: 100%;
				overflow: hidden;

				img {
					position: absolute;
					left: 0;
					right: 0;
					top: 0px;
					height: 200%;
					min-width: 100%;
					width: auto;
					display: none;
				}
			}

			.header-content {
				min-width: 100%;

				.header-inner {
					width: 100%;
					flex-wrap: wrap;
					margin: 0 auto;

					.header-title {
						padding: 1.5625vw 0;
						z-index: 2;

						.logo {
							width: 3rem;
							height: 3rem;
							flex-shrink: 0;
						}

						.title {
							font-weight: 800;
							font-size: 26px;

							.sub {
								display: none;
							}
						}
					}

					.slot {
						z-index: 1;
					}
				}
			}

			.pc {
				display: none;
				flex-shrink: 0;
			}
		}
	}
</style>